import { Skeleton } from '@/components/Skeleton';

/**
 * The route-level pending boundary — `FE-04.11`, `entry-surfaces.md` D5/D12.
 *
 * A generic shimmer, not the route's own loading shape: `D5`'s per-surface
 * skeletons (four sign-in field rows, group headings × tiles, …) are each
 * route's own job, because only the route knows what it is about to show.
 * This is the fallback every route gets for free before it bothers to shape
 * one — three rows is a reasonable stand-in for "a list of something" and
 * is never the last thing a member sees, because `pendingMinMs` (below)
 * guarantees it is replaced once real content or an empty state is ready.
 *
 * **Announces nothing.** D11 reserves the shell's one live region for
 * events with no `role` node of their own; a route whose loading state
 * takes long enough to be worth narrating ("Loading your boards") says so
 * itself, once, through `announce()` — a second, generic "Loading" from
 * this boundary on every route would be the double-announcement D11 warns
 * against. `aria-busy="true"` is the correct, silent signal here: it tells
 * assistive technology the region is mid-update without speaking over
 * whatever the page itself says.
 */
export const ROUTE_PENDING_MS = 300;
export const ROUTE_PENDING_MIN_MS = 500;

export function RoutePending() {
  return (
    <div aria-busy="true">
      <Skeleton shape="row" count={3} />
    </div>
  );
}
